import { z } from 'zod';

export type MessageFormatter = (msg: { id: string; defaultMessage: string }) => string;

const requiredMsg = { id: 'common.required', defaultMessage: 'Requerido' };

/**
 * Validates create-fragment fields. Uses passthrough so values like stationId
 * and platformUpload are kept when the resolver runs.
 */
export function getFragmentValidation(t: MessageFormatter) {
  return z
    .object({
      title: z.string().min(1, t(requiredMsg)),
      description: z.string().optional(),
      tags: z.array(z.string()).optional(),
      doExternalExport: z.boolean().optional(),
    })
    .passthrough();
}

/** @deprecated Use getFragmentValidation(t) for translated messages */
export const fragmentValidation = getFragmentValidation((msg) => msg.defaultMessage);
